var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./stream.static";
class ApiSmpStreamDestination {
}
_a = ApiSmpStreamDestination;
/**
 * Used to create new Stream Destination
 */
ApiSmpStreamDestination.create = (destinationPartial) => apiRequest({
    body: destinationPartial,
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/destination/`,
    method: "POST",
}, failureHash);
/**
 * Used to delete existing Stream Destination by id
 */
ApiSmpStreamDestination.destroy = ({ id }) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/destination/${id}`,
    method: "DELETE",
}, failureHash);
/**
 * Used to get Stream Destinations list
 */
ApiSmpStreamDestination.list = (req) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/destination/`,
        method: "GET",
        query: req === null || req === void 0 ? void 0 : req.query,
    }, failureHash)).results;
});
/**
 * Used to update existing Stream Destination
 */
ApiSmpStreamDestination.update = ({ destination, }) => apiRequest({
    body: destination,
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/destination/${destination.id}`,
    method: "PUT",
}, failureHash);
class ApiSmpStreamStream {
}
_b = ApiSmpStreamStream;
/**
 * Used to create new Stream
 */
ApiSmpStreamStream.create = ({ name, scheduled_for, variant, }) => apiRequest({
    body: {
        name,
        scheduled_for,
        variant,
    },
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/`,
    method: "POST",
}, failureHash);
/**
 * Used to delete existing Stream by id
 */
ApiSmpStreamStream.destroy = ({ id }) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/${id}`,
    method: "DELETE",
}, failureHash);
/**
 * Used to get Streams list
 */
ApiSmpStreamStream.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return (yield apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/`,
        method: "GET",
    }, failureHash)).results;
});
/**
 * Used to reset current stream's key
 */
ApiSmpStreamStream.resetKey = ({ id }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/${id}/reset-key`,
        method: "POST",
    }, failureHash);
});
/**
 * Used to start existing Stream by id
 */
ApiSmpStreamStream.start = ({ id }) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/${id}/start`,
    method: "POST",
}, failureHash);
/**
 * Used to stop started Stream by id
 */
ApiSmpStreamStream.stop = ({ id }) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/${id}/stop`,
    method: "POST",
}, failureHash);
/**
 * Used to update existing Stream
 */
ApiSmpStreamStream.update = ({ stream }) => apiRequest({
    body: stream,
    endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/stream/${stream.id}`,
    method: "PUT",
}, failureHash);
class ApiSmpStreamTranscodePreset {
}
_c = ApiSmpStreamTranscodePreset;
/**
 * Used to get Stream TranscodePresets list
 */
ApiSmpStreamTranscodePreset.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return (yield apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/stream/v1/transcode-preset/`,
        method: "GET",
    }, failureHash)).results;
});
export class ApiSmpStream {
}
ApiSmpStream.Destination = ApiSmpStreamDestination;
ApiSmpStream.Stream = ApiSmpStreamStream;
ApiSmpStream.TranscodePreset = ApiSmpStreamTranscodePreset;
//# sourceMappingURL=stream.js.map